import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import agentsActions from "../store/actions/agents";
import ModalContactAgent from "../components/Agents/ModalContactAgent";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import careersActions from "../store/actions/careers";

const AgentDetails = () => {
    const id = useParams();
    const agentsStore = useSelector((store) => store.agentsStore);
    const dispatch = useDispatch();
    const [agent, setAgent] = useState(null);

    const navigate = useNavigate();

    const openContactModal = () => {
        dispatch(agentsActions.setModalOpen(true));
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    const modalSuccessClose = () => {
        dispatch(agentsActions.setModalSuccessOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    const prev = useLocation().state

    const goBack = () => {
        if (prev === 'agent'){
            navigate(-1)
        } else {
            navigate('/find-an-agent')
        }
    }

    const getSocials = (list) => {
        let socialItems = false;
        if (list) {
            const socialsList = [];
            list.forEach(socialItem => {
                if (socialItem.type.name !== 'Agency Website') {
                    socialsList.push(socialItem);
                }
            })
            if (socialsList.length > 0) {
                socialItems = socialsList.map((socialObj) => (
                    <a key={socialObj.id} href={socialObj.link} target="_blank" className='social-item'>
                        <img src={socialObj.type.image.webPath} alt=""/>
                    </a>
                ));
            }
        }

        return socialItems;
    }

    const getLanguages = (list) => {
        if (list.length > 0) {
            return list.map((lang) => (
                <span className='language-item'>{lang.name}</span>
            ));
        } else {
            return <span>-</span>
        }
    }

    const getAgencyWebsiteList = (list) => {
        if (list) {
            const socialsList = [];
            list.forEach(socialItem => {
                if (socialItem.type.name === 'Agency Website') {
                    socialsList.push(socialItem);
                }
            })
            if (socialsList.length > 0) {
                return (
                    <div className="avatar-info-block website">
                        <a className="avatar-info-website" href={socialsList[0].link} target="_blank">
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/globe.svg`} alt="icon"/>
                            Agency Website
                        </a>
                    </div>
                );
            }
        }

        return false;
    }

    const formatTimeItem = (item) => {
        let itemArr = item.split('')
        if (itemArr[0] === '0') {
            itemArr.splice(0, 1);
        }
        let itemString = itemArr.join('')
        return itemString.toUpperCase()
    }

    const getMailingAddress = (list) => {
        const mailingAddressesList = [];
        list.forEach(address => {
            if (address.type === 'Mailing' && address.street && address.street.length > 0) {
                mailingAddressesList.push(address);
            }
        })
        let addressItems = false;
        if (mailingAddressesList.length > 0) {
            addressItems = mailingAddressesList.map((addressObj) => (
                <div key={addressObj.id} className="address-item">
                    {addressObj.street && (<span> {addressObj.street},</span>)}
                    {addressObj.city && (<span> {addressObj.city},</span>)}
                    {addressObj.state && (<span> {addressObj.state},</span>)}
                    {addressObj.postalCode && (<span> {formatPostalCode(addressObj.postalCode)}</span>)}
                </div>
            ));
        }

        return addressItems;
    }

    const getOfficeAddress = (list) => {
        const physicalAddressesList = [];
        list.forEach(address => {
            if (address.type === 'Physical' && address.street && address.street.length > 0) {
                physicalAddressesList.push(address);
            }
        })
        let addressItems = false;
        if (physicalAddressesList.length > 0) {
            addressItems = physicalAddressesList.map((addressObj) => (
                <div key={addressObj.id} className="address-block">
                    <div className="info-card__text">
                        {addressObj.street && (<span> {addressObj.street},</span>)}
                        {addressObj.city && (<span> {addressObj.city},</span>)}
                        {addressObj.state && (<span> {addressObj.state},</span>)}
                        {addressObj.postalCode && (<span> {formatPostalCode(addressObj.postalCode)}</span>)}
                    </div>
                    {addressObj.latitude && addressObj.longitude ? (
                        <a className="info-address-link" href={`https://maps.google.com/?q=${addressObj.latitude},${addressObj.longitude}`} target="_blank">Get directions</a>
                    ) : false}
                </div>
            ));
        }
        return addressItems;
    }

    const getAgentName = (agent) => {
        let agentName = '';
        if (agent.firstName) {
            agentName = agent.firstName
        }
        if (agent.middleName) {
            agentName = agentName + ' ' + agent.middleName
        }
        if (agent.lastName) {
            agentName = agentName + ' ' + agent.lastName
        }
        return agentName;
    }

    const getCompanyName = (agent) => {
        let agencyName = ''
        if (agent.agency && agent.agency.name !== getAgentName(agent)) {
            agencyName = agent.agency.name
        }
        return (
            <p className='avatar__company'>
                {agencyName}
            </p>
        )
    }

    const formatPostalCode = (zip) => {
        let value = zip.substring(0, 9);
        if (value.length > 5) {
            value = [value.slice(0, 5), '-', value.slice(5)].join('');
        }
        return value
    }

    const getPhones = (list) => {
        const phonesList = [];
        list.forEach(phone => {
            if (phone.type.name !== 'Free') {
                phonesList.push(phone);
            }
        })
        let phones = false;
        if (phonesList.length > 0) {
            phones = phonesList.map((phoneObj) => (
                <a key={phoneObj.id} href={`tel:${phoneObj.number}`} className="phone-item">
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/phone-icon.svg`} alt=""/>
                    {formatPhone(phoneObj.number)}
                </a>
            ));
        }
        return phones;
    }

    const getPhonesFree = (list) => {
        const phonesList = [];
        list.forEach(phone => {
            if (phone.type.name === 'Free') {
                phonesList.push(phone);
            }
        })
        let phones = false;
        if (phonesList.length > 0) {
            phones = phonesList.map((phoneObj) => (
                <div className="phone-item">
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/phone-icon.svg`} alt=""/>
                    {formatPhone(phoneObj.number)}
                </div>
            ));
        }

        return phones;
    }

    const formatPhone = (phone) => {
        const numberArr = phone.split('');
        let numberInScopes = `${numberArr[0]}${numberArr[1]}${numberArr[2]}`;
        let numberFirstPart = `${numberArr[3]}${numberArr[4]}${numberArr[5]}`;
        let numberSecondPart = `${numberArr[6]}${numberArr[7]}${numberArr[8]}${numberArr[9]}`;
        return `(${numberInScopes}) ${numberFirstPart}-${numberSecondPart}`
    }

    const agentAbout = (agent) => {
        if (agent.biography && agent.biography.length > 0) {
            return (
                <div className="info-block about">
                    <h3 className='info-subtitle'>
                        About me
                    </h3>
                    <div className='info-about' dangerouslySetInnerHTML={{__html: agent.biography}}/>
                </div>
            )
        }

        return false
    }

    const mailingAddress = (agent, className) => {
        let addressItems = false;
        if (agent.addresses && agent.addresses.length > 0) {
            addressItems = getMailingAddress(agent.addresses)
        }
        if (addressItems) {
            return (
                <div className={`info-card mailing-address ${className}`}>
                    <div className="info-card__title">Mailing Address</div>
                    <div className="info-card__text">
                        {getMailingAddress(agent.addresses)}
                    </div>
                </div>
            )
        }

        return false
    }

    const officeAddress = (agent) => {
        let addressItems = false;
        if (agent.addresses && agent.addresses.length > 0) {
            addressItems = getOfficeAddress(agent.addresses)
        }
        if (addressItems) {
            return (
                <div className="info-card office-address">
                    <div className="info-card__title">Office Address</div>
                    {addressItems}
                </div>
            )
        }

        return false
    }

    const agentPhones = (agent) => {
        let phoneItems = false;
        if (agent.phones && agent.phones.length > 0) {
            phoneItems = getPhones(agent.phones)
        }
        if (phoneItems) {
            return (
                <div className="info-card phone">
                    <div className="info-card__title">Phone Number</div>
                    <div className="info-card__text">
                        {phoneItems}
                    </div>
                </div>
            )
        }

        return false;

    }

    const agentPhonesFree = (agent) => {
        let phoneItems = false;
        if (agent.phones && agent.phones.length > 0) {
            phoneItems = getPhonesFree(agent.phones)
        }
        if (phoneItems) {
            return (
                <div className="info-card phone-free">
                    <div className="info-card__title">Toll Free Phone</div>
                    <div className="info-card__text">
                        {getPhonesFree(agent.phones)}
                    </div>
                </div>
            )
        }

        return false

    }

    const schedule = (agent) => {
        const daysNameArr = []
        const daysObjectsArr = []

        if (agent.operationHours && agent.operationHours.length > 0) {
            agent.operationHours.forEach(day => {
                if (!daysNameArr.includes(day.day)) {
                    daysNameArr.push(day.day)
                    daysObjectsArr.push(day)
                }
            })
        }

        if (daysObjectsArr.length > 0) {

            return (
                <div className="info-card working-days">
                    <div className="info-card__title">Office Hours</div>
                    <div className="info-card__list">
                        {daysObjectsArr.map((dayItem) => (
                                <div key={dayItem.id} className="day-item" >
                                    <div className="day-item__day">{dayItem.day}: </div>
                                    {dayItem.status ? (
                                        <div className="day-item__time">{formatTimeItem(dayItem.startTime)} - {formatTimeItem(dayItem.endTime)}</div>
                                    ) : (
                                        <div className="day-item__time closed">Closed</div>
                                    )}
                                </div>
                            )
                        )}
                    </div>
                </div>
            )
        }

        return false;

    }

    const agentLanguages = (agent) => {
        if (agent.languages && agent.languages.length > 0) {
            return (
                <div className="avatar-info-block block-languages">
                    <h4 className='avatar__subtitle'>
                        Languages Spoken
                    </h4>
                    <div className='avatar__lang-list'>
                        {getLanguages(agent.languages)}
                    </div>
                </div>
            )
        }

        return false;
    }

    const agentSocials = (agent) => {
        let socialItems = false;
        if (agent.socialMedia && agent.socialMedia.length > 0) {
            socialItems = getSocials(agent.socialMedia)
        }
        if (socialItems) {
            return (
                <div className="socials-content">
                    <h4 className='avatar__subtitle'>
                        Social Media
                    </h4>
                    <div className='avatar__social-list'>
                        {socialItems}
                    </div>
                </div>
            )
        }

        return false
    }

    useEffect(() => {
        dispatch(agentsActions.fetchAgent(id))
    }, []);

    useEffect(() => {
        setAgent(agentsStore.currentAgent)
    }, [agentsStore.currentAgent]);

    return (
        <div className={`find-an-agent details ${agentsStore.isLoading ? 'is-loading' : ''}`}>
            <div className="agent-details-spinner"/>
            {agentsStore.modalOpen &&
                <ModalContactAgent/>
            }
            <div className={`modal-success ${agentsStore.modalSuccessOpen ? 'open' : ''}`}>
                <div className="modal-success-container">
                    <button type="button" className="button-close" onClick={() => modalSuccessClose()}>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                    </button>
                    <img className="modal-success-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/icon-success.svg`}/>
                    <div className="modal-success-title">Done!</div>
                    <div className="modal-success-text">Your message has been sent.</div>
                    <button className="modal-success-btn button-gradient" onClick={() => modalSuccessClose()}>Back To Agent</button>
                </div>
            </div>
            <div className="container">
                {agent && (
                <div className='agent-details'>
                    <button
                        type='button'
                        className='agent-details__go-back-btn'
                        onClick={() => goBack()}
                    >
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/back.svg`}/>
                        Agent Search
                    </button>
                    <div className='agent-details__container'>
                        <div className='avatar'>
                            <div className="avatar-info-group group-main">
                                <h2 className='avatar__name'>
                                    {getAgentName(agent)}
                                </h2>
                                {getCompanyName(agent)}
                                <img className='avatar__img' src={agent.image && agent.image.webPath} alt=""/>
                                <button
                                    type='button'
                                    className='avatar__btn button-gradient'
                                    onClick={() => openContactModal(agent)}
                                >
                                    Email Agent
                                </button>
                            </div>
                            <div className="avatar-info-group group-secondary">
                                {agentLanguages(agent)}
                                <div className="avatar-info-block block-socials">
                                    {agentSocials(agent)}
                                    {getAgencyWebsiteList(agent.socialMedia)}
                                </div>
                            </div>
                        </div>
                        <div className="info">
                            <div className="info-row">
                                <div className="info-col left">
                                    <div className="phones-row">
                                        {agentPhones(agent)}
                                        {agentPhonesFree(agent)}
                                    </div>
                                    {officeAddress(agent)}
                                    {mailingAddress(agent, 'desktop')}
                                </div>
                                <div className="info-col right">
                                    {agentPhonesFree(agent)}
                                    {schedule(agent)}
                                    {mailingAddress(agent, 'mobile')}
                                </div>
                            </div>
                            {agentAbout(agent)}
                        </div>
                    </div>
                </div>
                )}
            </div>
        </div>

    )
};

export default AgentDetails;
